module.exports = __webpack_public_path__ + "static/media/GRD.a3da5056.png";